"use client";

import {ForwardedRef, forwardRef, useContext} from "react";
import {
	Input as RACInput,
	FieldErrorContext,
	useSlottedContext,
	InputContext,
} from "react-aria-components";
import clsMerge from "../../util/clsMerge";

interface InputProps extends React.ComponentProps<typeof RACInput> {
	skipCustomStyles?: boolean;
}

/**
 * An input field that supports error states using react-aria-components.
 * https://react-spectrum.adobe.com/react-aria/TextField.html
 */
const Input = (props: InputProps, ref: ForwardedRef<HTMLInputElement>) => {
	const {children, className, skipCustomStyles = false, ...inputProps} = props;

	const errorContext = useContext(FieldErrorContext);
	const fieldContext = useSlottedContext(InputContext);

	return (
		<RACInput
			className={clsMerge(
				!skipCustomStyles && "input",
				"p-4",
				!skipCustomStyles && errorContext?.isInvalid && "input-error",
				fieldContext?.disabled && "input-disabled",
				className
			)}
			ref={ref}
			{...inputProps}
		>
			{children}
		</RACInput>
	);
};

export default forwardRef<HTMLInputElement, InputProps>(Input);
